import React, { useState, useEffect, useRef} from 'react';
import '../css/CompanyHouseDetails.css'
import { useSelector, useDispatch } from 'react-redux';
import PopupPDFViewer from './PopupPDFViewer.js'
import {
  fetchCompanyDetails,
  setViewChouseDetails
} from '../slices/chouseSlice.js'
import logo from '../assets/logo.png'

import Checkbox from '@mui/material/Checkbox';

import chtypes from '../helpers/chouseenumerated.js'
import parse from 'html-react-parser'

const {formatDate, formatDateShort} = require('../helpers/dates.js')

function CompanyHouseFilings() {
    const dispatch = useDispatch();
    const [jsvisible,setjsVisible] = useState(false)
    const [openpdf, setOpenPdf] = useState(false)
    const [pdfhef, setPDFhref] = useState("")

  
    const companyName = useSelector(state => state.chouse.companyName);
    const companyNumber = useSelector(state => state.chouse.companyNumber);
    const company = useSelector(state => state.chouse.company);
    const filings = useSelector(state => state.chouse.filings)
    const registered_office_address = useSelector(state => state.chouse.registered_office_address)
    const auth = useSelector(state => state.auth)
    const updatedat = useSelector(state => state.chouse.updatedat)
    const loaded = useSelector(state => state.chouse.loaded)
    const lead = useSelector(state => state.data.rowdata)
    const [timenow,setTimeNow] = useState(Date.now())
    const [filters,setFilters] = useState({})


    function isdate(datein) {
        try {
          const dt = new Date(datein)
          if(dt instanceof Date && !isNaN(new Date(dt).valueOf()))
            return true;
          return false;
        }catch(err) {
          return false;
        }
      }
      function replacePlaceholders(template, data) {
        if(typeof template === 'undefined' || typeof data !== 'object' || template === null || data === null)
            return template??""
        return template.replace(/{(.*?)}/g, (_, key) => {
          if(isdate(data[key]))
            return formatDate(data[key]) ?? `{${key}}`; 
          return data[key] ?? `{${key}}`; // fallback to original if key missing
        });
      }
    
      function filingDesc(item) {
        if(typeof item === 'undefined' || item === null)
          return "";
        let input = replacePlaceholders(chtypes.filing_descriptions[item.description], item.description_values??{})
        // Replace any ** with <strong></strong>
        const output = input.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
        return output;
      }
    
    const viewPDF = (e) => {
        e.preventDefault();
        setTimeNow(Date.now())
        console.log()
        setPDFhref(e.target.href)
        setOpenPdf(true)
    }
    const updateFilter = (e) => {
        let tmpFilters = JSON.parse(JSON.stringify(filters))
        if( e.target.checked)
            tmpFilters[e.target.value] = e.target.checked
        else if(typeof tmpFilters[e.target.value] !== 'undefined')
            delete tmpFilters[e.target.value]
        setFilters(tmpFilters)
    }

    function applyFilters(item) {
        if(Object.keys(filters).length > 0) {
            for(const key of Object.keys(filters) ) {
                if(item.category === key)
                    return item
            }
            return null;
        }else
            return item
    }

    const closePDFViewer = (status) => {
        setOpenPdf(false)
        setTimeNow(Date.now())
        setPDFhref("")
    }
      if(company && Object.keys(company).length > 0  && companyNumber && typeof companyNumber !== 'undefined')
        return (
            <>
            {openpdf && <PopupPDFViewer open={openpdf} close={closePDFViewer} url={pdfhef} time={timenow} /> }
            <div className="filter-div">
            <form id="filing-history-filter" className="form grid-row small-font">
            <fieldset id='filtergroup' className="govuk-!-margin-top-2">
                <legend className="hidden">Filter by category</legend>
                <div className="column-quarter">
                <h2 className="heading-medium govuk-!-margin-top-0 govuk-!-margin-bottom-3">Filter by category</h2>
                    <label for="show-filing-type" className="block-label selection-button-checkbox selected">
                        <input id="show-filing-type" type="checkbox" onClick={() => setjsVisible((state)=> !state)}/>
                        <strong>Show filing type</strong>
                    </label>
                </div><br/>
                <div className="column-quarter">
                <fieldset>
                    <legend className="hidden">Confirmation statement filters</legend>
                    <label for="filter-category-accounts" className="block-label selection-button-checkbox selection-button-checkbox-small">
                    <input id="filter-category-accounts" name="category" value="accounts" type="checkbox" checked={ (filters['accounts']??false) } onChange={updateFilter}   inputProps={{ 'aria-label': 'controlled' }} />
                    Accounts
                    </label>

                    <label for="filter-category-capital" className="block-label selection-button-checkbox selection-button-checkbox-small">
                        <input id="filter-category-capital" name="category" value="capital" type="checkbox" checked={filters['capital']??false}  onChange={updateFilter} />
                        Capital
                    </label>

                    <label for="filter-category-mortgage" className="block-label selection-button-checkbox selection-button-checkbox-small">
                        <input id="filter-category-mortgage" name="category" value="mortgage" type="checkbox"  checked={filters['mortgage']??false} onChange={updateFilter} />
                        Charges
                    </label>

                </fieldset>
                </div>
                <div className="column-half">
                <label for="filter-category-confirmation-statement" className="block-label selection-button-checkbox selection-button-checkbox-small">
                    <input id="filter-category-confirmation-statement" name="category" value="confirmation-statement" type="checkbox"  checked={filters['confirmation-statement']??false} onChange={updateFilter}/>
                    Confirmation statements / Annual returns
                </label>

                <label for="filter-category-incorporation" className="block-label selection-button-checkbox selection-button-checkbox-small">
                    <input id="filter-category-incorporation" name="category" value="incorporation" type="checkbox"   checked={filters['incorporation']??false} onChange={updateFilter}/>
                    Incorporation
                </label>

                <label for="filter-category-officers" className="block-label selection-button-checkbox selection-button-checkbox-small">
                    <input id="filter-category-officers" name="category" value="officers" type="checkbox"  checked={filters['officers']??false} onChange={updateFilter}/>
                    Officers
                </label>
                </div>
            </fieldset>

            </form>
        </div>
        <div className='filing-history-content'>
            <table className='full-width-table'>
            <thead>
                <tr>
                    <th class="nowrap">Date <span class="hidden">(document was filed at Companies House)</span></th>
                    <th class="filing-type sft-toggled " style={{display: `${jsvisible?'block':'none'}` }}>Type</th>
                    <th>Description <span class="hidden">(of the document filed at Companies House)</span></th>
                    <th class="nowrap">View / Download <span class="hidden">(PDF file, link opens in new window)</span></th>
                </tr>
            </thead>
            <tbody>
                {filings?.items?.filter(item => applyFilters(item))?.map((item,index) => (
                    <tr key={`tr_${index}_c1_filings`} >
                    <td key={`tr_${index}_c2_filings`} class="nowrap">{formatDateShort(item.date)}</td>
                    <td key={`tr_${index}_c3_filings`} class="filing-type sft-toggled" style={{display: `${jsvisible?'block':'none'}` }} >{item.type}</td>
                    <td key={`tr_${index}_c4_filings`} >{parse(filingDesc(item))}</td>
                    <td key={`tr_${index}_c5_filings`} class="nowrap">
                    <div>
                        <a href={item.links.document_metadata}  class="download link-updater-js govuk-link" onClick={viewPDF} data-link={item.links.document_metadata} >
                        View PDF
                        <span class="hidden">{filingDesc(item)} - link opens in a new window  - {item.pages} pages</span>
                        </a>({item.pages} pages)
                    </div>
                    </td>
                </tr>
                ))}
            </tbody>
            </table>
        </div>
        </>
        )
}

export default CompanyHouseFilings
    
  
  